import * as forumUrls from 'mk2/apps/forum/urls';
import { DynamicRoute } from 'mk2/containers/Application/Application';

export const routes: DynamicRoute[] = [{
    app: 'forum',
    exact: true,
    path: forumUrls.forum,
    getPage: () => {
        return import('mk2/apps/forum/containers/FeedNewest/FeedNewestPage' /* webpackChunkName: "forum.FeedNewest" */);
    },
    modules: [ 'mk2/apps/forum/containers/FeedNewest/FeedNewestPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumSubscribed,
    getPage: () => {
        return import('mk2/apps/forum/containers/FeedSubscribed/FeedSubscribedPage' /* webpackChunkName: "forum.FeedSubscribed" */);
    },
    modules: [ 'mk2/apps/forum/containers/FeedSubscribed/FeedSubscribedPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumUpdated,
    getPage: () => {
        return import('mk2/apps/forum/containers/FeedUpdated/FeedUpdatedPage' /* webpackChunkName: "forum.FeedUpdated" */);
    },
    modules: [ 'mk2/apps/forum/containers/FeedUpdated/FeedUpdatedPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumLiked,
    getPage: () => {
        return import('mk2/apps/forum/containers/FeedLiked/FeedLikedPage' /* webpackChunkName: "forum.FeedLiked" */);
    },
    modules: [ 'mk2/apps/forum/containers/FeedLiked/FeedLikedPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumCommented,
    getPage: () => {
        return import('mk2/apps/forum/containers/FeedCommented/FeedCommentedPage' /* webpackChunkName: "forum.FeedCommented" */);
    },
    modules: [ 'mk2/apps/forum/containers/FeedCommented/FeedCommentedPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumReported,
    getPage: () => {
        return import('mk2/apps/forum/containers/FeedReported/FeedReportedPage' /* webpackChunkName: "forum.FeedReported" */);
    },
    modules: [ 'mk2/apps/forum/containers/FeedReported/FeedReportedPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumTopics,
    getPage: () => {
        return import('mk2/apps/forum/containers/ForumCategories/ForumCategoriesPage' /* webpackChunkName: "forum.ForumCategories" */);
    },
    modules: [
        'mk2/apps/forum/containers/ForumCategories/ForumCategoriesPage',
        'mk2/apps/forum/containers/ForumTopics/ForumTopicsPage',
    ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumTopicsCategory,
    getPage: () => {
        return import('mk2/apps/forum/containers/ForumTopics/ForumTopicsPage' /* webpackChunkName: "forum.ForumTopics" */);
    },
    modules: [ 'mk2/apps/forum/containers/ForumTopics/ForumTopicsPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumBrandDaysArchive,
    getPage: () => {
        return import('mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaignsPage' /* webpackChunkName: "forum.ArchivedCampaigns" */);
    },
    modules: [ 'mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaignsPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumTopicModeratorInvitation,
    getPage: () => {
        return import('mk2/apps/forum/containers/TopicModeratorInvitation/TopicModeratorInvitationPage' /* webpackChunkName: "forum.TopicModeratorInvitation" */);
    },
    modules: [ 'mk2/apps/forum/containers/TopicModeratorInvitation/TopicModeratorInvitationPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumTopicInfo,
    getPage: () => {
        return import('mk2/apps/forum/containers/TopicInfo/TopicInfoPage' /* webpackChunkName: "forum.TopicInfo" */);
    },
    modules: [ 'mk2/apps/forum/containers/TopicInfo/TopicInfoPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumTopicExplanation,
    getPage: () => {
        return import('mk2/apps/forum/containers/TopicCreateExplanation/TopicCreateExplanationPage' /* webpackChunkName: "forum.TopicCreateExplanation" */);
    },
    modules: [ 'mk2/apps/forum/containers/TopicCreateExplanation/TopicCreateExplanationPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumTopicNewInCategory,
    getPage: () => {
        return import('mk2/apps/forum/containers/TopicCreate/TopicCreatePage' /* webpackChunkName: "forum.TopicCreate" */);
    },
    modules: [
        'mk2/apps/forum/containers/TopicCreate/TopicCreatePage',
        'mk2/apps/forum/containers/ForumCategories/ForumCategoriesPage',
    ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumTopicEdit,
    getPage: () => {
        return import('mk2/apps/forum/containers/TopicEdit/TopicEditPage' /* webpackChunkName: "forum.TopicEdit" */);
    },
    modules: [ 'mk2/apps/forum/containers/TopicEdit/TopicEditPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumTopic,
    getPage: () => {
        return import('mk2/apps/forum/containers/Topic/TopicPage' /* webpackChunkName: "forum.Topic" */);
    },
    modules: [ 'mk2/apps/forum/containers/Topic/TopicPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumContestNew,
    getPage: () => {
        return import('mk2/apps/forum/containers/ContestCreate/ContestCreatePage' /* webpackChunkName: "forum.ContestCreate" */);
    },
    modules: [ 'mk2/apps/forum/containers/ContestCreate/ContestCreatePage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumContestEdit,
    getPage: () => {
        return import('mk2/apps/forum/containers/ContestEdit/ContestEditPage' /* webpackChunkName: "forum.ContestEdit" */);
    },
    modules: [ 'mk2/apps/forum/containers/ContestEdit/ContestEditPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumTestingNew,
    getPage: () => {
        return import('mk2/apps/forum/containers/TestingCreate/TestingCreatePage' /* webpackChunkName: "forum.TestingCreate" */);
    },
    modules: [ 'mk2/apps/forum/containers/TestingCreate/TestingCreatePage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumTestingEdit,
    getPage: () => {
        return import('mk2/apps/forum/containers/TestingEdit/TestingEditPage' /* webpackChunkName: "forum.TestingEdit" */);
    },
    modules: [ 'mk2/apps/forum/containers/TestingEdit/TestingEditPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumPostNew,
    getPage: () => {
        return import('mk2/apps/forum/containers/PostCreate/PostCreateSelectCategoryPage' /* webpackChunkName: "forum.ForumCategories" */);
    },
    modules: [ 'mk2/apps/forum/containers/PostCreate/PostCreateSelectCategoryPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumPostNewInCategory,
    getPage: () => {
        return import('mk2/apps/forum/containers/PostCreate/PostCreateSelectTopicPage' /* webpackChunkName: "forum.ForumTopics" */);
    },
    modules: [ 'mk2/apps/forum/containers/PostCreate/PostCreateSelectTopicPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumPostNewInTopic,
    getPage: () => {
        return import('mk2/apps/forum/containers/PostCreate/PostCreatePage' /* webpackChunkName: "forum.PostCreate" */);
    },
    modules: [ 'mk2/apps/forum/containers/PostCreate/PostCreatePage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumCounsellingNew,
    getPage: () => {
        return import('mk2/apps/forum/containers/CounsellingQuestionCreate/CounsellingQuestionCreatePage' /* webpackChunkName: "forum.CounsellingQuestionCreate" */);
    },
    modules: [ 'mk2/apps/forum/containers/CounsellingQuestionCreate/CounsellingQuestionCreatePage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumCounsellingReply,
    getPage: () => {
        return import('mk2/apps/forum/containers/CounsellingReply/CounsellingReplyPage' /* webpackChunkName: "forum.CounsellingReply" */);
    },
    modules: [ 'mk2/apps/forum/containers/CounsellingReply/CounsellingReplyPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumPostEdit,
    getPage: () => {
        return import('mk2/apps/forum/containers/PostEdit/PostEditPage' /* webpackChunkName: "forum.PostEdit" */);
    },
    modules: [ 'mk2/apps/forum/containers/PostEdit/PostEditPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumPostLikers,
    getPage: () => {
        return import('mk2/apps/forum/containers/PostLikers/PostLikersPage' /* webpackChunkName: "forum.PostLikers" */);
    },
    modules: [ 'mk2/apps/forum/containers/PostLikers/PostLikersPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumPostCommentLikers,
    getPage: () => {
        return import('mk2/apps/forum/containers/PostCommentLikers/PostCommentLikersPage' /* webpackChunkName: "forum.PostCommentLikers" */);
    },
    modules: [ 'mk2/apps/forum/containers/PostCommentLikers/PostCommentLikersPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumPostDetail,
    getPage: () => {
        return import('mk2/apps/forum/containers/PostDetail/PostDetailPage' /* webpackChunkName: "forum.PostDetail" */);
    },
    modules: [ 'mk2/apps/forum/containers/PostDetail/PostDetailPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumTestingCommentNew,
    getPage: () => {
        return import('mk2/apps/forum/containers/CommentCreate/CommentCreatePage' /* webpackChunkName: "forum.CommentCreate" */);
    },
    modules: [ 'mk2/apps/forum/containers/CommentCreate/CommentCreatePage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumCommentEdit,
    getPage: () => {
        return import('mk2/apps/forum/containers/CommentEdit/CommentEditPage' /* webpackChunkName: "forum.CommentEdit" */);
    },
    modules: [ 'mk2/apps/forum/containers/CommentEdit/CommentEditPage' ],
}, {
    app: 'forum',
    exact: true,
    path: forumUrls.forumSearch,
    getPage: () => {
        return import('mk2/apps/forum/containers/ForumSearch/ForumSearchPage' /* webpackChunkName: "forum.ForumSearch" */);
    },
    modules: [ 'mk2/apps/forum/containers/ForumSearch/ForumSearchPage' ],
}];
